const URLDATA = {
  //api base url
  API_URI: process.env.REACT_APP_API_URL,
};

export const STRIPE_KEYS = {
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  STRIPE_CLIENT_KEY: process.env.REACT_APP_STRIPE_CLIENT_KEY,
}

export default URLDATA;
